import { Component, EventEmitter, Output, Input, ViewChild, TemplateRef, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirm-deleting',
  templateUrl: './confirm-deleting.component.html',
  styleUrls: ['./confirm-deleting.component.css']
})
export class ConfirmDeletingComponent implements AfterViewInit, OnDestroy {
  @Output() onConfirm = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();
  @Input() item!:any;
  @Input() title:string='';
  @Input() deletedName:string='';
  @ViewChild('dialogRef', { read: TemplateRef }) dialogRef!: TemplateRef<any>;
  subscription?:Subscription;
  isDialogOpened:boolean=false;
  constructor(
    private matDialog:MatDialog,
    ){
      
  }
    ngAfterViewInit(): void {
      if(!this.isDialogOpened){
        this.isDialogOpened=true;
  
      this.matDialog.open(this.dialogRef, {
        width: '350px',
      });
      this.subscription=this.matDialog.afterAllClosed.subscribe(()=>{
        if(this.onCancel)
        this.onCancel.emit();
      });
    }
      }
      ngOnDestroy(): void {
        this.subscription?.unsubscribe();
      }
  confirm(){
    this.onConfirm.emit(this.item);
    this.close();
  }
  close(){
    this.matDialog.closeAll();
  
  }
  }
  